"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var fb_like_component_1 = require("./fb-like.component");
var google_plus_component_1 = require("./google-plus.component");
var tweet_component_1 = require("./tweet.component");
var linkedin_share_component_1 = require("./linkedin-share.component");
var pin_it_component_1 = require("./pin-it.component");
var JwSocialButtonsModule = /** @class */ (function () {
    function JwSocialButtonsModule() {
    }
    JwSocialButtonsModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        fb_like_component_1.FbLikeComponent,
                        google_plus_component_1.GooglePlusComponent,
                        tweet_component_1.TweetComponent,
                        linkedin_share_component_1.LinkedInShareComponent,
                        pin_it_component_1.PinItComponent
                    ],
                    exports: [
                        fb_like_component_1.FbLikeComponent,
                        google_plus_component_1.GooglePlusComponent,
                        tweet_component_1.TweetComponent,
                        linkedin_share_component_1.LinkedInShareComponent,
                        pin_it_component_1.PinItComponent
                    ]
                },] },
    ];
    return JwSocialButtonsModule;
}());
exports.JwSocialButtonsModule = JwSocialButtonsModule;
